import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { MdEdit } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { CrudIcon, Search } from 'src/components';
import DragableTable from 'src/components/DragableTable';
import { onDragEnd } from 'src/components/DragableTable/onDragEnd';
import Button from 'src/components/button';
import Loader from 'src/components/loader';
import { fetchLabel } from 'src/redux/action/label.action';
import { RootState } from 'src/redux/reducers';
import AddLabel from './crud/AddLabel';
interface IProps {}

const Label: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [query, setQuery] = React.useState<string>('');
  const [editLabel, setEditLabel] = useState<boolean>(false);
  const [editLabelId, setEditLabelId] = useState('');
  const [editLabelData, setEditLabelData] = useState([]);
  const [orderData, setOrderData] = useState<any>([]);
  const [pageSize, setPageSize] = useState<any>(0);
  const [pageIndex, setPageIndex] = useState<any>(0);

  const dispatch = useDispatch();
  const { labelData, error, loading } = useSelector(
    ({ itemLabel }: RootState) => itemLabel
  );
  const handleModal = () => {
    setShowModal(!showModal);
  };

  const onDragEndHandler = (result: any) => {
    onDragEnd(
      result,
      orderData,
      setOrderData,
      labelData,
      '/labels/order',
      pageSize,
      pageIndex
    );
  };

  React.useEffect(() => {
    dispatch(fetchLabel() as any);
  }, [dispatch]);

  const searchLabelData = labelData?.filter((item: any) => {
    if (query === '') {
      return item;
    } else if (item?.name?.toLowerCase().includes(query.toLowerCase())) {
      return item;
    }
  });

  const handleEditLabel = (data: any) => {
    setEditLabel(true);
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
    setEditLabelData(data);
    setEditLabelId(data.id);
  };

  const handleButtonClick = () => {
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
    setEditLabel(false);
    setEditLabelData([]);
  };

  const tableColumn = [
    {
      Header: 'Label Name',
      accessor: 'name',
    },
    {
      Header: 'No. of category',
      accessor: (row: any) => row.numberOfCategories,
    },

    {
      Header: 'Action',
      Cell: (row: any) => (
        <CrudIcon
          data={row?.cell?.row?.original}
          url="/labels"
          fetchData={fetchLabel() as any}
        >
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handleEditLabel(row?.cell?.row?.original)}
          >
            <MdEdit color="#4062FF" />
          </div>
        </CrudIcon>
      ),
    },
  ];

  const dataTable = React.useMemo(() => {
    return orderData.length > 0 ? orderData : searchLabelData;
  }, [orderData, searchLabelData]);
  return (
    <>
      <div className="grid-cols-12 gap-4 grid z-2 text-black">
        <div className="col-span-12">
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search label"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add Label'}
              variant="primary"
              onClick={handleButtonClick}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          {loading ? (
            <Loader />
          ) : (
            <DragableTable
              onDragEnd={onDragEndHandler}
              pagination={true}
              tableColumn={tableColumn}
              tableData={dataTable}
              setPageIndex={setPageIndex}
              setPageSizes={setPageSize}
            />
          )}
        </div>
      </div>
      <AddLabel
        editLabelData={editLabelData}
        editLabel={editLabel}
        editLabelId={editLabelId}
        setEditLabel={setEditLabel}
        setEditLabelId={setEditLabelId}
        fetchData={() => {}}
        handleModal={handleModal}
        showModal={showModal}
      />
    </>
  );
};

export default React.memo(Label);
